import React, { useState, useLayoutEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link } from "react-router-dom";
import "./navigation.css";
import Button from "react-bootstrap/Button";
import Logo from "../logo/Logo";
import BlackLogo from "../black-logo/BlackLogo";
import ContactForm from "../contactus-popup/ContactForm";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Col, Row } from "react-bootstrap";
import { HiChevronDown } from "react-icons/hi";

const Navigation = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [toggle, setToggle] = useState(false);

  useLayoutEffect(() => {
    window.addEventListener("scroll", chanagebg);

    return () => {
      window.removeEventListener("scroll", chanagebg);
    };
  }, []);

  const chanagebg = () => {
    if (window.scrollY > 90) {
      setToggle(true);
      //   console.log('true')
    } else if (window.scrollY < 90) {
      setToggle(false);
    }
  };

  const [showed, setShowed] = useState(false);
  const showDropdown = (e) => {
    setShowed(!show);
  };
  const hideDropdown = (e) => {
    setShowed(false);
  };

  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleMouseEnter = (dropdownName) => setActiveDropdown(dropdownName);
  const handleMouseLeave = () => setActiveDropdown(null);

  return (
    <div className="navbar_section">
      <Navbar
        expand="lg"
        className={
          toggle === true
            ? "newNavebar bg-transparent navbar_section_navbar"
            : "bg-transparent navbar_section_navbar"
        }
      >
        <Container fluid className="nav_padding">
          <a href="/">{toggle === true ? <Logo /> : <BlackLogo />}</a>
          <Link to="/"></Link>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <div className="d-flex align-items-center svg_icon" id= "hide_nav">
                <NavDropdown
                  className="desktop_menu"
                  title="Solutions"
                  id="basic-nav-dropdown"
                  show={activeDropdown === "solutions"}
                  onMouseEnter={() => handleMouseEnter("solutions")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="desktop_megamenu">
                    <Row>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Solutions</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/solutions/agentic-ai-overview">
                                Agentic AI Overview
                              </Link>
                            </p>
                            <p>
                              <Link
                                to="/solutions/service-desk-autoresolver"
                              >
                                Servive Desk AutoResolver (L1 → L2)
                              </Link>
                            </p>
                            <p>
                              <Link to="/solutions/cloud-cost-ops-agent">
                                Cloud Cost-Ops Agent (FinOps)
                              </Link>
                            </p>
                            <p>
                              <Link to="/solutions/document-ops-agent">
                                Document Ops Agent (SOW/Contracts)
                              </Link>
                            </p>
                            <p>
                              <Link to="/solutions/live-demons-and-pocs">
                                Live Demons & POCs
                              </Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </NavDropdown>
                <HiChevronDown />
              </div>
                <p  className='nav_items' >
               <Link to="/services/ai-consulting-and-strategy">
               Agentic AI</Link>
            </p>
                <p  className='nav_items' >
               <Link to='/digital'>
               Digital</Link>
            </p>
                <p  className='nav_items' >
               <Link to='/blog'>
               Blog</Link>
            </p>

              <div className="d-flex align-items-center svg_icon" id="hide_nav">
                <NavDropdown
                  className="desktop_menu"
                  title="Portfolio"
                  id="basic-nav-dropdown"
                  show={activeDropdown === "Portfolio"}
                  onMouseEnter={() => handleMouseEnter("Portfolio")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="desktop_megamenu">
                    <Row>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Products</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/products/product-a">Product A</Link>
                            </p>
                            <p>
                              <Link to="/products/product-b">Product B</Link>
                            </p>
                            <p>
                              <Link to="/products/product-c">Product C</Link>
                            </p>
                            <p>
                              <Link to="/products/all-products">
                                All Products →
                              </Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Use Cases</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/use-Cases/usecase-1">UseCase 1</Link>
                            </p>
                            <p>
                              <Link to="/use-Case/usecase-2">Usecase 2</Link>
                            </p>
                            <p>
                              <Link to="/use-Case/usecase-3">Usecase 3</Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Browse by</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/browse-by/funtion">
                                Function: (IT Ops, FinOps, DocOp, HR, Sales Ops)
                              </Link>
                            </p>
                            <p>
                              <Link to="/technology/blockchain">
                                Industry: (Tech, retail, Healthcare, BFSI)
                              </Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </NavDropdown>
                <HiChevronDown />
              </div>

              <div className="d-flex align-items-center svg_icon">
                <NavDropdown
                  className="desktop_menu"
                  title="Services"
                  id="basic-nav-dropdown"
                  show={showed}
                  onMouseEnter={showDropdown}
                  onMouseLeave={hideDropdown}
                >
                  <div className="desktop_megamenu">
                    <Row>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">
                            Consulting & delivery
                          </h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/services/ai-consulting-and-strategy">
                                AI Consulting & Strategy
                              </Link>
                            </p>
                            <p>
                              <Link to="/services/enterprice-application">
                                Enterprise Application Development
                              </Link>
                            </p>
                            <p>
                              <Link to="/services/product-development">
                                Product Development (web/mobile)
                              </Link>
                            </p>
                            <p>
                              <Link to="/services/api-intergration">
                                API Integration
                              </Link>
                            </p>
                            <p>
                              <Link to="/testing">Testing / QA</Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Design & Data</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/services/ux-ui-design">
                                UX/UI Design
                              </Link>
                            </p>
                            <p>
                              <Link to="/data-science">AI & Data Science</Link>
                            </p>
                            <p>
                              <Link to="/insights/business-intelligence">
                                Business Intelligence
                              </Link>
                            </p>
                            {/* <p>
                              <Link to="/insights/cognitive">
                                Cognitive Computing (AI/ML)
                              </Link>
                            </p>

                            <p>
                              <Link to="/insights/extended-reality">
                                Extended Reality (AR/VR)
                              </Link>
                            </p> */}
                          </div>
                        </div>
                      </Col>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">
                            Platforms & Cloud
                          </h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/insights/cloud">Cloud</Link>
                            </p>
                            <p>
                              <Link to="/technology/blockchain">
                                Blockchain App & Services
                              </Link>
                            </p>

                            <p>
                              <Link to="/technology/salesforce">
                                Salesforce
                              </Link>
                            </p>
                            <p>
                              <Link to="/technology/service-now">
                                Service Now
                              </Link>
                            </p>
                            <p>
                              <Link to="/technology/sharepoint">
                                Sharepoint
                              </Link>
                            </p>
                            <p>
                              <Link to="/technology/netsuite">Net Suite</Link>
                            </p>
                            <p>
                              <Link to="/technology/oracle">Oracle</Link>
                            </p>
                            <p>
                              <Link to="/technology/open-source">
                                Open Source
                              </Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </NavDropdown>
                <HiChevronDown />
              </div>
              <div className="mobile_menu">
                <div className="  mob_svg_icon " style={{display:"none"}}>
                  <NavDropdown title="Solutions" id="basic-nav-dropdown">
                    <p>
                      <Link to="/solutions/agentic-ai-overview">
                        Agentic AI Overview
                      </Link>
                    </p>
                    <p>
                      <Link
                        to="/solutions/
                              service-desk-autoresolver"
                      >
                        Servive Desk AutoResolver (L1 → L2)
                      </Link>
                    </p>
                    <p>
                      <Link to="/solutions/cloud-cost-ops-agent">
                        Cloud Cost-Ops Agent (FinOps)
                      </Link>
                    </p>
                    <p>
                      <Link to="/solutions/document-ops-agent">
                        Document Ops Agent (SOW/Contracts)
                      </Link>
                    </p>
                    <p>
                      <Link to="/solutions/live-demons-and-pocs">
                        Live Demons & POCs
                      </Link>
                    </p>
                  </NavDropdown>

                  <HiChevronDown />
                </div>
                <div className="  mob_svg_icon " style={{display:"none"}}>
                  <NavDropdown title="Portfolio" id="basic-nav-dropdown">
                    <NavDropdown title="Products" id="basic-nav-dropdown">
                      <p>
                        <Link to="/products/product-a">Product A</Link>
                      </p>
                      <p>
                        <Link to="/products/product-b">Product B</Link>
                      </p>
                      <p>
                        <Link to="/products/product-c">Product C</Link>
                      </p>
                      <p>
                        <Link to="/products/all-products">All Products →</Link>
                      </p>
                    </NavDropdown>

                    <NavDropdown title="Use Cases" id="basic-nav-dropdown">
                      <p>
                        <Link to="/use-cases/usecase-1">UseCase 1</Link>
                      </p>
                      <p>
                        <Link to="/use-case/usecase-2">Usecase 2</Link>
                      </p>
                      <p>
                        <Link to="/use-case/usecase-3">Usecase 3</Link>
                      </p>
                    </NavDropdown>
                    <NavDropdown title="Browse By" id="basic-nav-dropdown">
                      <p>
                        <Link to="browse-by/funtion">
                          Function: ( IT Ops, FinOps, DocOp, HR, Sales Ops )
                        </Link>
                      </p>
                      <p>
                        <Link to="/technology/blockchain">
                          Industry: (Tech, retail, Healthcare, BFSI)
                        </Link>
                      </p>
                    </NavDropdown>
                  </NavDropdown>
                  <HiChevronDown />
                </div>
                <div className="  mob_svg_icon ">
                  <NavDropdown title="Services" id="basic-nav-dropdown">
                    <NavDropdown
                      title="Consulting & Delivery"
                      id="basic-nav-dropdown"
                    >
                      <p>
                        <Link to="/services/ai-consulting-and-strategy">
                          AI Consulting & Strategy
                        </Link>
                      </p>
                      <p>
                        <Link to="/services/enterprice-application">
                          Enterprise Application Development
                        </Link>
                      </p>
                      <p>
                        <Link to="/services/product-development">
                          Product Development (web/mobile)
                        </Link>
                      </p>
                      <p>
                        <Link to="/services/api-intergration">
                          API Integration
                        </Link>
                      </p>
                      <p>
                        <Link to="/testing">Testing / QA</Link>
                      </p>
                    </NavDropdown>

                    <NavDropdown title="Design & Data" id="basic-nav-dropdown">
                      <p>
                        <Link to="/services/ux-ui-design">UX/UI Design</Link>
                      </p>
                      <p>
                        <Link to="/data-science">AI & Data Science</Link>
                      </p>
                      <p>
                        <Link to="/insights/business-intelligence">
                          Business Intelligence
                        </Link>
                      </p>
                    </NavDropdown>

                    <NavDropdown
                      title="Platforms & Cloud"
                      id="basic-nav-dropdown"
                    >
                      <p>
                        <Link to="/insights/cloud">Cloud</Link>
                      </p>
                      <p>
                        <Link to="/technology/blockchain">
                          Blockchain App & Services
                        </Link>
                      </p>

                      <p>
                        <Link to="/technology/salesforce">Salesforce</Link>
                      </p>
                      <p>
                        <Link to="/technology/service-now">Service Now</Link>
                      </p>
                      <p>
                        <Link to="/technology/sharepoint">Sharepoint</Link>
                      </p>
                      <p>
                        <Link to="/technology/netsuite">Net Suite</Link>
                      </p>
                      <p>
                        <Link to="/technology/oracle">Oracle</Link>
                      </p>
                      <p>
                        <Link to="/technology/open-source">Open Source</Link>
                      </p>
                    </NavDropdown>
                  </NavDropdown>
                  <HiChevronDown />
                </div>

                {/* <div className=" mob_svg_icon">
                  <NavDropdown title="Trust" id="basic-nav-dropdown">
                    <p>
                      <Link to="/insights/cognitive">
                        Cognitive Computing (AI/ML)
                      </Link>
                    </p>
                    <p>
                      <Link to="/insights/business-intelligence">
                        Business Intelligence
                      </Link>
                    </p>
                    <p>
                      <Link to="/insights/extended-reality">
                        Extended Reality (AR/VR)
                      </Link>
                    </p>
                    <p>
                      <Link to="/insights/cloud">Cloud</Link>
                    </p>
                  </NavDropdown>
                  <HiChevronDown />
                </div>
                <div className="  mob_svg_icon">
                  <NavDropdown title="Technology" id="basic-nav-dropdown">
                    <p>
                      <Link to="/technology/blockchain">Blockchain</Link>
                    </p>
                    <p>
                      <Link to="/technology/sharepoint">Sharepoint</Link>
                    </p>
                    <p>
                      <Link to="/technology/salesforce">Salesforce</Link>
                    </p>
                    <p>
                      <Link to="/technology/service-now">Service Now</Link>
                    </p>
                    <p>
                      <Link to="/technology/netsuite">Net Suite</Link>
                    </p>
                    <p>
                      <Link to="/technology/oracle">Oracle</Link>
                    </p>
                    <p>
                      <Link to="/technology/open-source">Open Source</Link>
                    </p>
                  </NavDropdown>
                  <HiChevronDown />
                </div> */}
                <div className="  mob_svg_icon">
                  <NavDropdown title="Trust" id="basic-nav-dropdown">
                    <p>
                      <Link to="/services/responsible-and-ethical-ai">
                        Responsible & Ethical AI → Principles → Practices →
                        Governance
                      </Link>
                    </p>
                    <p>
                      <Link to="/trust/security-and-compliance">
                        Security & Compliance → SOC2 / ISO Roadmap → Data Flow →
                        DPDP / GDPR
                      </Link>
                    </p>
                    <p>
                      <Link to="/trust/privacy-and-data-handling">
                        Privacy & Data Handling
                      </Link>
                    </p>
                    <p>
                      <Link to="/trust/certifications-and-partner-programs">
                        Certifications & Partner Programs
                      </Link>
                    </p>
                    <p>
                      <Link to="/trust/procurement-faq">Procurement FAQ</Link>
                    </p>
                  </NavDropdown>
                  <HiChevronDown />
                </div>
                <div className="  mob_svg_icon"style={{display:"none"}}>
                  <NavDropdown title="Resources" id="basic-nav-dropdown">
                    <p>
                      <Link to="/resources/case-studies">Case Studies</Link>
                    </p>
                    <p>
                      <Link to="/blog">
                        Insights (Blog)
                      </Link>
                    </p>
                    <p>
                      <Link to="/resources/downloadables">
                        Downloadables (Ethical AI Charter, Security Brief, Pilot
                        Checklist)
                      </Link>
                    </p>
                    <p>
                      <Link to="/resources/events-and-webinars">
                        Events / Webinars
                      </Link>
                    </p>
                  </NavDropdown>{" "}
                  <HiChevronDown />
                </div>
                <div className="  mob_svg_icon">
                  <NavDropdown title="Company" id="basic-nav-dropdown">
                  <p>
                              <Link to="/about">About</Link>
                            </p>

                            <p style={{display:"none"}}>
                              <Link to="/company/our-approach">
                                Our Approach (Discover → Design → Deploy)
                              </Link>
                            </p>
                            <p style={{display:"none"}}>
                              <Link to="/expertise">
                                Expertise
                              </Link>
                              </p>
                            <p>
                              <Link to="/careers">Careers</Link>
                            </p>
                            <p style={{display:"none"}}>
                              <Link to="/company/contact">Contact</Link>
                            </p>
                          </NavDropdown>
                          <HiChevronDown/>


                          </div>
              </div>

              <div className="d-flex align-items-center svg_icon" >
                <NavDropdown
                  className="desktop_menu"
                  title="Trust"
                  id="basic-nav-dropdown"
                  show={activeDropdown === "Trust"}
                  onMouseEnter={() => handleMouseEnter("Trust")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="desktop_megamenu">
                    <Row>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Trust</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/services/responsible-and-ethical-ai">
                                Responsible & Ethical AI → Principles →
                                Practices → Governance
                              </Link>
                            </p>
                            <p>
                              <Link to="/trust/security-and-compliance">
                                Security & Compliance → SOC2 / ISO Roadmap →
                                Data Flow → DPDP / GDPR
                              </Link>
                            </p>
                            <p>
                              <Link to="/trust/privacy-and-data-Handling">Privacy & Data Handling
                              </Link>
                            </p>
                            <p>
                              <Link to="/trust/certifications-and-partner-programs">
                                Certifications & Partner Programs
                              </Link>
                            </p>
                            <p>
                              <Link to="/trust/procurement-faq">
                                Procurement FAQ
                              </Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </NavDropdown>
                <HiChevronDown />
              </div>
              <div className="d-flex align-items-center svg_icon" id="hide_nav">
                <NavDropdown
                  className="desktop_menu"
                  title="Resources"
                  id="basic-nav-dropdown"
                  show={activeDropdown === "Resources"}
                  onMouseEnter={() => handleMouseEnter("Resources")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="desktop_megamenu">
                    <Row>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Resources</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/resources/case-studies">
                                Case Studies
                              </Link>
                            </p>
                            <p>
                              <Link to="/blog">
                                Insights (Blog)
                              </Link>
                            </p>
                            <p>
                              <Link to="/resources/downloadables">
                                Downloadables (Ethical AI Charter, Security
                                Brief, Pilot Checklist)
                              </Link>
                            </p>
                            <p>
                              <Link to="/resources/events-and-webinars">
                                Events / Webinars
                              </Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </NavDropdown>
                <HiChevronDown />
              </div>
              <div className="d-flex align-items-center svg_icon">
                <NavDropdown
                  className="desktop_menu"
                  title="Company"



                  id="basic-nav-dropdown"
                  show={activeDropdown === "Company"}
                  onMouseEnter={() => handleMouseEnter("Company")}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="desktop_megamenu">
                    <Row>
                      <Col>
                        <div className="mega_menu_items">
                          <h2 className="mega_menu_header">Company</h2>
                          <div className="mega_menu_list_items">
                            <p>
                              <Link to="/about">About</Link>
                            </p>
                            <p style={{display:"none"}}>
                              <Link to="/company/our-approach">
                                Our Approach (Discover → Design → Deploy)
                              </Link>
                            </p>
                            <p>
                              <Link to="/careers">Careers</Link>
                            </p>
                            <p style={{display:"none"}}>
                              <Link to="/expertise">
                                Expertise
                              </Link>
                              </p>
                            <p style={{display:"none"}}>
                              <Link to="/company/contact">Contact</Link>
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </NavDropdown>
                <HiChevronDown />
              </div>
              {/* <p className='nav_items' >
                <a href="#products">Products & Solutions</a>
             </p> */}
              {/* <p className='nav_items' >
                <a href="#company">Company</a>
             </p> */}
              <div>
                <Button
                  className="nav_bar_btn"
                  variant="outline-primary"
                  onClick={handleShow}
                >
                  {/* <a href="#contact"> Contact Us </a> */}
                  Book a Demo
                </Button>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <ContactForm show={show} onClose={handleClose} onShow={handleShow} />
    </div>
  );
};

export default Navigation;
